import React, { Component } from 'react'
import {css} from 'glamor'
import Globals from './../Globals'

import Button from './Button'
import Text from './Text'
import logo from '../imgs/about2-logo.png'
import logoBlue from '../imgs/about3-logo.png'
import logoRed from '../imgs/about4-logo.png'

const styles = {
  hero:css({
    "width": "100%"
  }),
  container:css({
    width: '90%',
    "height": "770px",
    margin: '0 auto',
    '@media(min-width: 1024px)':{
      maxWidth: 1024
    }
  }),
  main: css({
    "position": "relative",
    "top": "50%",
    "transform": "translateY(-50%)",
    "MozTransform": "translateY(-50%)",
    "WebkitTransform": "translateY(-50%)",
    "MsTransform": "translateY(-50%)",
    "OTransform": "translateY(-50%)", 
    display: 'flex',
    flexFlow: 'column',
    '@media(min-width: 1024px)':{
      flexFlow: 'row',
    },
    '> div':{
      flex: 1
    }
  }),
  logo: css({
    maxWidth: 150,
    display: 'block',
    margin: '0 auto',
    '@media(min-width: 570px)':{
      maxWidth: '100%'
    }
  }),
  header: css({
    "backgroundImage": `linear-gradient(to right, ${Globals.colors.red}, ${Globals.colors.purple}), linear-gradient(${Globals.colors.white}, ${Globals.colors.white})`,
    "fontFamily": Globals.fonts.bold,
    "fontSize": "36px",
    "lineHeight": "1.39",
    "WebkitBackgroundClip": "text",
    "backgroundClip": "text",
    textTransform: 'uppercase',
    "WebkitTextFillColor": "transparent"
  }),
  description: css({
    "fontFamily": Globals.fonts.regular,
    "fontSize": "18px",
    "lineHeight": "1.67",
    "color": Globals.colors.white
  })
}

const content = {
  id: 'evento',
  title: {
    type: 'h3',
    header: 'Pandora has no boundaries',
      color: [Globals.colors.red,Globals.colors.yellow]
  },
    title2: {
        type: 'h3',
        header: 'Get together with your friends!',
        color: [Globals.colors.red,Globals.colors.purple]
    },
    title3: {
        type: 'h3',
        header: 'You don\'t need internet connection, you don\'t even need an App!',
        color: [Globals.colors.green,Globals.colors.blue]
    },
  role: 'link',
  img: logo,
  alt: 'PandoraMore',
  description: 'It doesn\'t matter where you are. Just bring your Pandora with you. As long as you have your Pandora and your friends with you, you can play the games whenever you are! Just put it on the table and unleash the fun!..',
    description2: 'We design the Pandora as a small box that brings people together in any place and as the interface between players via their phones to track the games’ progress. The Pandora will help players to communicate face-to-face while they play games.',
    description3: 'Pandora is an amazing tool to having fun with friends. We design the Pandora as a small box that brings people together in any place and as the interface between players via their phones to track the games’ progress. The Pandora will help players to communicate face-to-face while they play games.'
}

export default class AboutMore extends Component {

    render(){
        return (
        <div {...styles.hero} role={content.role} id={content.id}>
          <div {...styles.container}>
            <div  {...styles.main}>
              <div>
                <Text type={content.title.type} label={content.title.header} color={content.title.color}/>
                <p {...styles.description}>{content.description}</p>

              </div>
                <div>
                    <img src={logoRed} alt={content.alt} {...styles.logo} />
                </div>
            </div>

          </div>
            <div {...styles.container}>
                <div  {...styles.main}>

                    <div>
                        <img src={logo} alt={content.alt} {...styles.logo} />
                    </div>
                    <div>
                        <Text type={content.title2.type} label={content.title2.header} color={content.title2.color}/>
                        <p {...styles.description}>{content.description2}</p>
                    </div>
                </div>
            </div>

            <div {...styles.container}>
                <div  {...styles.main}>
                    <div>
                        <Text type={content.title3.type} label={content.title3.header} color={content.title3.color}/>
                        <p {...styles.description}>{content.description3}</p>
                    </div>
                    <div>
                        <img src={logoBlue} alt={content.alt} {...styles.logo} />
                    </div>
                </div>
            </div>
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/componentes/AboutMore.js